module.exports = __webpack_public_path__ + "img/stamp-pay.3f3b740e.png";